export default {
  toasts: {
    failed_to_save_changes: 'Salvarea modificărilor a eșuat.',
    successfully_saved: 'Salvat cu succes.',
  },
  form: {
    has_multiple_locations: {
      label: 'Setați locații diferite pentru săptămână',
    },
  },
  labels: {
    day_location: 'Locație {{day}} {{index}}',
    selected_days: 'Zile selectate',
    orders_paused: 'Comenzi întrerupte',
    open_time: 'Oră deschidere',
    close_time: 'Oră închidere',
  },
  buttons: {
    save: 'Salvați',
  },
};
